export default __webpack_public_path__ + "static/media/problem.52630744.svg";